import React from 'react'
import styles from './index.module.scss'

interface BoardCreateTaskBtnProps {
    onClick?: () => void
}

export default function BoardCreateTaskBtn({ onClick }: BoardCreateTaskBtnProps){
    return (
        <div className={styles.boardCreateTaskBtn}>
            <div className={styles.boardCreateTaskBtn__btn} onClick={onClick}>
                <img src="/icon/plus.svg" alt="plus"/>
                Создать задачу
            </div>
        </div>
    )
}
